import React from 'react';
import styled from '@emotion/styled';
import scale from '../../core/utilities/scale';
import { Colors } from '../constants';

export interface QRCodeProps {
  labelLine1: React.ReactNode;
  labelLine2: React.ReactNode;
  qrCodeIcon: React.ReactNode;
}

export default function QRCode({
  labelLine1,
  labelLine2,
  qrCodeIcon,
}: QRCodeProps): JSX.Element {
  return (
    <Container>
      <QRCodeArea>{qrCodeIcon}</QRCodeArea>
      <LabelContainer>
        <LabelLine1>{labelLine1}</LabelLine1>
        <LabelLine2>{labelLine2}</LabelLine2>
      </LabelContainer>
    </Container>
  );
}

const Container = styled.div({
  alignSelf: 'center',
  width: scale(515),
  height: scale(181),
  border: `3px solid ${Colors.BORDER_PRIMARY}`,
  borderRadius: scale(31),
  display: 'flex',
  flexDirection: 'row',
  gap: scale(17),
  alignItems: 'flex-end',
  padding: `0 ${scale(32)}`,
});

const QRCodeArea = styled.div({
  alignSelf: 'center',
  position: 'relative',
  width: scale(129),
  height: scale(129),
});

const LabelContainer = styled.div({
  alignSelf: 'center',
  display: 'flex',
  flexDirection: 'column',
});

const LabelLine1 = styled.div({
  fontSize: scale(28.8),
  lineHeight: scale(43.2),
  fontWeight: 500,
  color: '#8C8C8C',
});

const LabelLine2 = styled.div({
  fontSize: scale(28.8),
  lineHeight: scale(43.2),
  fontWeight: 600,
  color: '#000000',
});
